import React from 'react';
import PropTypes from 'prop-types';
import s from './LoginSuccessful.scss';

class LoginSuccessful extends React.PureComponent {
  render() {
    return (
      <div className={s.login_message_box}>
        <p>Successfully logged in to The Times Of India, Enjoy reading...</p>
        <span className={s.close} onClick={() => this.props.onClick()} />
      </div>
    );
  }
}

LoginSuccessful.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default LoginSuccessful;
